import styled, { css } from "styled-components";

import {
  Table as TableAnt,
  Button as ButtonAnt,
  Modal as ModalAnt,
} from "antd";

import { InformationCircle } from "../../../styles/Icons";

export const Modal = styled(ModalAnt)`
  .title {
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
  }
  .span-info {
    font-size: 1.2rem;
    color: var(--gray-550);
  }

  .ant-modal-body {
    padding-top: 0;
  }
`;
export const Table = styled(TableAnt)`
  width: 100%;
  margin-top: 0.3rem;
  .actived {
    color: var(--green-700);
  }

  .no-actived {
    color: var(--gray-550);
  }
`;

export const ContentName = styled.div`
  display: flex;

  span {
    text-transform: capitalize;
  }
`;

export const ActionIcon = styled(InformationCircle)`
  width: 30px;
  height: 30px;
  color: var(--orange-150);

  :hover {
    cursor: pointer;
  }
`;

interface IButton {
  actionType:
    | "default"
    | "send"
    | "inactivate"
    | "activate"
    | "open_courses"
    | "update_magic_link";
}

export const Button = styled(ButtonAnt)<IButton>`
  border-radius: 0.3rem;
  color: var(--white);

  &&&:disabled {
    background-color: #d4d4d4;
    color: #a09d9d;
    &&&:hover {
      background-color: #d4d4d4;
      color: var(--white);
    }
  }

  ${({ actionType }) => {
    if (actionType === "default") {
      return css`
        background-color: var(--gray-100);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(189, 189, 189);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(210, 210, 210);
          color: var(--white);
        }
      `;
    }

    if (actionType === "inactivate") {
      return css`
        background-color: var(--red-600);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(209, 53, 53);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(229, 115, 115);
          color: var(--white);
        }
      `;
    }
    if (actionType === "activate") {
      return css`
        background-color: var(--green-700);
        &&&:hover,
        &&&:focus,
        &&&:focus-within {
          background-color: rgb(45, 124, 45);
          color: var(--white);
        }
        &.ant-btn-loading {
          background-color: rgb(85, 164, 85);
          color: var(--white);
        }
      `;
    }
  }}

  @media (max-width: 768px) {
    padding: 0 8px;
    font-size: 0.8rem;
    height: 28px;
  }
`;
